import { createMagicDoorContext } from '~/contexts/utils';
import { OwnersRepository } from '~/repositories/ownersRepository';
import type { PostOwnerContributionDto, RequestOwnerContributionDto, UpdateOwnerContributionDto } from '~/swagger/portal/Api';

const repo = new OwnersRepository();
export const [OwnerContributionProvider, useOwnerContribution] = createMagicDoorContext('OwnerContribution', () => {
  const addOwnerContribution = async (payload: PostOwnerContributionDto) => {
    await repo.addOwnerContribution(payload);
  };

  const addOwnerContributionRequest = async (payload: RequestOwnerContributionDto) => {
    await repo.addOwnerContributionRequest(payload);
  };

  const editOwnerContribution = async (ownerContributionId: string, payload: UpdateOwnerContributionDto) => {
    const res = await repo.editOwnerContribution(ownerContributionId, payload);
    return res;
  };

  return {
    addOwnerContribution,
    addOwnerContributionRequest,
    editOwnerContribution,
  };
});
